import { createContext, useContext, useEffect, useState } from "react";


export const AuthContext = createContext()

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null)
    const [accessToken, setAccessToken] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [permissions, setPermissions] = useState([])
    const [zones, setZones] = useState([])
    const [cities, setCities] = useState([])
    useEffect(() => {
        const storedUser = localStorage.getItem('user')
        const storedToken = localStorage.getItem('access_token')
        const storedPermissions = localStorage.getItem('permissions')
        const storedZones = localStorage.getItem('zones')
        const storedCities = localStorage.getItem('cities')
        setUser(storedUser ? JSON.parse(storedUser) : null)
        setPermissions(storedPermissions ? JSON.parse(storedPermissions) : [])
        setAccessToken(storedToken || null)
        setZones(storedZones ? JSON.parse(storedZones) : [])
        setCities(storedCities ? JSON.parse(storedCities) : [])
        setIsLoading(false)
    }, [])
    const login = (userData, accessToken) => {
        setUser(userData);
        setAccessToken(accessToken);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('access_token', accessToken);
        localStorage.setItem('permissions', JSON.stringify(userData.permissions));
        localStorage.setItem('zones', JSON.stringify(userData.zones));
        localStorage.setItem('cities', JSON.stringify(userData.cities));
    }
    const logout = () => {
        setUser(null);
        setAccessToken(null);
        localStorage.removeItem("user");
        localStorage.removeItem("access_token");
        localStorage.removeItem("permissions");
        localStorage.removeItem("zones");
        localStorage.removeItem("cities");
    };
    return (
        <AuthContext.Provider value={{
            user,
            accessToken,
            isLoading,
            setIsLoading,
            isAuthenticated: !!accessToken,
            login,
            logout,
            permissions,
            zones,
            cities,
        }}>
            {children}
        </AuthContext.Provider>
    )
}
export function useAuth() {
    return useContext(AuthContext);
}